import styled, { css } from 'styled-components';
import { BKJIcon } from '../BKJIcon/BKJIcon.js';
export const Avatar = styled.img `
  border: 1px solid ${({ theme }) => theme.colors.Grey3};
  border-radius: 50%;
  ${({ fontSize }) => fontSize &&
    css `
      width: ${fontSize}px;
      height: ${fontSize}px;
    `}
`;
export const PendingSignUpIcon = styled(BKJIcon) `
  position: absolute;
  ${({ width }) => width &&
    css `
      top: calc(${width} / 1.8);
      left: calc(${width} / 1.8);
      width: calc(${width} / 3.5);
    `};
`;
export const ImageContainer = styled.div `
  position: relative;
`;
//# sourceMappingURL=BKJAvatar.styled.js.map